module.exports = __webpack_public_path__ + "static/media/schedule.18b9a1d6.svg";